import { useSelector } from 'react-redux';

import { Button } from '@alfalab/core-components/button';

import { RootState } from '@utils/types';

export const ButtonSubmit: React.FC = () => {
    const { loading, isReady }: any = useSelector<RootState>((state) => state.submit);

    return (
        <Button disabled={!isReady} loading={loading} type='submit' view='primary' block={true}>
            Перевести
        </Button>
    );
};
